import { EventSiteEditStyles } from 'features/EventSiteEditStyles';

const EditWebStyles = (): JSX.Element => {
	return <EventSiteEditStyles />;
};
export default EditWebStyles;
